import { render } from "./form_question_mapping.html?vue&type=template&id=83f46820&external"
import script from "./form_question_mapping.js?vue&type=script&lang=js&external"
export * from "./form_question_mapping.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__